(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Mobile drawer ---------- */
  var drawer = $('[data-drawer]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('no-scroll', open);
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var c = $('.drawer__head button', drawer); if (c) c.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) setDrawer(true);
    else if (e.target.closest('[data-drawer-close]')) setDrawer(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setDrawer(false); closeCart(); } });

  /* ---------- Carousels ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel] [data-dir]');
    if (!btn) return;
    var track = $('.carousel__track', btn.closest('[data-carousel]'));
    track.scrollBy({ left: Number(btn.dataset.dir) * track.clientWidth * 0.85, behavior: 'smooth' });
  });

  /* ---------- Search: prefix query with chosen category ---------- */
  $$('[data-search-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var sel = $('select', form), q = $('input[name="q"]', form);
      if (sel && sel.value && q) q.value = (sel.value + ' ' + q.value).trim();
    });
  });

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html, isError) {
    var t = $('[data-toast]');
    if (!t) return;
    t.innerHTML = html;
    t.classList.toggle('toast--error', !!isError);
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 4500);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* ---------- Cart count ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function refreshCartCount() {
    return fetch(window.theme.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  var useDrawer = !!(window.theme.cartDrawer && cartDrawer && !document.body.classList.contains('template-cart'));
  var lastFocus = null;

  function openCart() {
    if (!useDrawer) return false;
    lastFocus = document.activeElement;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var panel = $('.cdrawer__panel', cartDrawer);
    setTimeout(function () { if (panel) panel.focus(); }, 60);
    return true;
  }
  function closeCart() {
    if (!cartDrawer || !cartDrawer.classList.contains('is-open')) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderCart(html) {
    if (!html || !cartDrawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer-inner]', doc);
    var current = $('[data-cart-drawer-inner]', cartDrawer);
    if (fresh && current) {
      current.parentNode.replaceChild(fresh, current);
      setCount(Number(fresh.getAttribute('data-count')) || 0);
    }
  }
  function reloadCart() {
    return fetch(window.theme.rootUrl + (window.theme.rootUrl.slice(-1) === '/' ? '' : '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCart(data['cart-drawer']); })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]') && useDrawer) {
      e.preventDefault();
      openCart();
      reloadCart();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }

    var qtyBtn = cartDrawer && e.target.closest('[data-cart-drawer] [data-line]');
    if (!qtyBtn) return;
    var inner = $('[data-cart-drawer-inner]', cartDrawer);
    if (inner) inner.classList.add('is-loading');
    fetch(window.theme.changeJs, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: Number(qtyBtn.dataset.line),
        quantity: Number(qtyBtn.dataset.qty),
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(esc(res.d.description || res.d.message || 'No pudimos actualizar el carrito.'), true);
          return reloadCart();
        }
        renderCart(res.d.sections && res.d.sections['cart-drawer']);
      })
      .catch(function () { toast('No pudimos actualizar el carrito. Probá de nuevo.', true); })
      .then(function () { var i = $('[data-cart-drawer-inner]', cartDrawer); if (i) i.classList.remove('is-loading'); });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-cart-form]')) return;
    e.preventDefault();
    var btn = $('button[type="submit"]', form);
    var lbl = btn ? ($('[data-btn-label]', btn) || btn) : null;
    var original = lbl ? lbl.innerHTML : '';
    if (btn) btn.disabled = true;
    if (lbl) lbl.textContent = 'Agregando…';
    var body = new FormData(form);
    if (useDrawer) {
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
    }
    fetch(window.theme.addJs, { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(esc(res.d.description || 'No pudimos agregar el producto.'), true); return; }
        if (useDrawer && res.d.sections && res.d.sections['cart-drawer']) {
          renderCart(res.d.sections['cart-drawer']);
          openCart();
          return;
        }
        toast(esc(res.d.product_title) + ' agregado <a href="' + window.theme.cartUrl + '">Ver carrito</a>');
        return refreshCartCount();
      })
      .catch(function () { toast('No pudimos agregar el producto. Probá de nuevo.', true); })
      .then(function () { if (btn) btn.disabled = false; if (lbl) lbl.innerHTML = original; });
  });

  /* ---------- Collection filters: auto-submit ---------- */
  $$('[data-filters]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  /* ---------- Product page: variants + gallery ---------- */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('[data-variants]', root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];

    function showMedia(id) {
      if (!id) return;
      var slide = $('[data-media-id="' + id + '"]', root);
      if (!slide) return;
      $$('.gallery__slide', root).forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) showMedia(t.dataset.thumb);
    });

    var form = $('[data-cart-form]', root);
    if (!form || variants.length < 2) return;

    form.addEventListener('change', function (e) {
      if (!e.target.matches('.opt input')) return;
      var chosen = $$('[data-option]', form).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
      var v = variants.filter(function (x) {
        return x.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      var addBtn = $('[data-add]', form), notify = $('[data-notify]', root), price = $('[data-price]', root);
      var addLbl = addBtn ? ($('[data-btn-label]', addBtn) || addBtn) : null;
      if (!v) { if (addBtn) { addBtn.disabled = true; addLbl.textContent = 'No disponible'; } return; }
      $('[data-variant-id]', form).value = v.id;
      if (price) price.innerHTML = v.price;
      if (addBtn) { addBtn.disabled = !v.available; addLbl.textContent = v.available ? 'Agregar al carrito' : 'Agotado'; }
      if (notify) notify.hidden = v.available;
      showMedia(v.media);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    });
  });

  /* ---------- Related products ---------- */
  $$('[data-recs]').forEach(function (el) {
    if (!el.dataset.url || $('.section', el)) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-recs]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------- Device finder ---------- */
  $$('[data-finder]').forEach(function (root) {
    var brandSel = $('[data-finder-brand]', root);
    var modelSel = $('[data-finder-model]', root);
    var go = $('[data-finder-go]', root);
    var data = $('[data-finder-data]', root);

    function reset() {
      modelSel.innerHTML = '<option value="">Elegí el modelo</option>';
      modelSel.disabled = true; go.disabled = true;
    }
    brandSel.addEventListener('change', function () {
      reset();
      if (brandSel.value === '') return;
      var list = $('[data-brand="' + brandSel.value + '"]', data);
      if (!list) return;
      var groups = {};
      $$('li', list).forEach(function (li) {
        var a = $('a', li);
        var opt = document.createElement('option');
        opt.value = a.getAttribute('href');
        opt.textContent = a.textContent.trim();
        var g = li.dataset.group || '';
        if (g) {
          if (!groups[g]) { groups[g] = document.createElement('optgroup'); groups[g].label = g; modelSel.appendChild(groups[g]); }
          groups[g].appendChild(opt);
        } else {
          modelSel.appendChild(opt);
        }
      });
      modelSel.disabled = false;
    });
    modelSel.addEventListener('change', function () { go.disabled = !modelSel.value; });
    go.addEventListener('click', function () { if (modelSel.value) window.location.href = modelSel.value; });
  });

  /* ---------- Hero slider ---------- */
  $$('[data-slider]').forEach(function (root) {
    var track = $('.hero__track', root);
    var slides = $$('.hero__slide', root);
    var dots = $$('[data-dot]', root);
    if (!track || slides.length < 2) return;
    var index = 0, timer = null;
    var speed = Number(root.dataset.speed) || 6000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function mark(n) { dots.forEach(function (d, k) { d.setAttribute('aria-current', k === n ? 'true' : 'false'); }); }
    function go(n) {
      index = (n + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(index);
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { index = Math.round(track.scrollLeft / track.clientWidth); mark(index); }, 80);
    }, { passive: true });
    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-dot]');
      if (d) { go(Number(d.dataset.dot)); return; }
      var a = e.target.closest('[data-hero-dir]');
      if (a) go(index + Number(a.dataset.heroDir));
    });
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (root.dataset.autoplay !== 'true' || reduce) return;
      timer = setInterval(function () { if (!document.hidden) go(index + 1); }, speed);
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    root.addEventListener('touchstart', stop, { passive: true });
    document.addEventListener('shopify:block:select', function (e) {
      var s = e.target.closest && e.target.closest('.hero__slide');
      if (s && root.contains(s)) { stop(); go(Number(s.dataset.index)); }
    });
    start();
  });

  /* ---------- Tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (!tab) return;
    var root = tab.closest('[data-tabs]');
    $$('[data-tab]', root).forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
    $$('[data-panel]', root).forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
  });
})();
